import React from 'react';
import styled, { css, keyframes } from 'styled-components';

export const Loader = ({ background }: { background?: string }) => {
  return (
    <LoaderContainer $background={background}>
      <LoaderContent>
        <LetterI>l</LetterI>
        <Orbit />
      </LoaderContent>
    </LoaderContainer>
  );
};

const orbitAnimation = keyframes`
  0% {
    transform: rotate(0deg) translateX(50px);
  }
  100% {
    transform: rotate(360deg) translateX(50px);
  }
`;

const LoaderContainer = styled.div<{ $background?: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  ${props =>
    props.$background
      ? `background-color: ${props.$background}`
      : `background-color: rgba(255, 255, 255, 0.9);`}
`;

const LoaderContent = styled.div`
  position: relative;
  width: 120px;
  height: 120px;
`;

const LetterI = styled.div`
  font-size: 40px;
  font-weight: bold;
  color: #000;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const Orbit = styled.div`
  width: 10px;
  height: 10px;
  background-color: red;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform-origin: center 0px;
  animation: ${orbitAnimation} 2s linear infinite;
`;

export default Loader;
